export const server = "https://server.jansetu.co.in/api/v1";
// export const server = "https://103.189.80.13:5005/api/v1";

export const defaultUserImage = "";
